var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseSp02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#002445;}.a,.c{opacity:0;}.c{fill:#fff;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 44,
    height: 40,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-286 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, 286, 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 22,
    rx: 2,
    transform: "translate(9 9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(300.223 23) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(295 32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 4,
    rx: 1,
    transform: "translate(297.393 41.385) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseSp02);
export default __webpack_public_path__ + "static/media/icon_close_sp_02.9e07e0938a6860168f986ae278864a68.svg";
export { ForwardRef as ReactComponent };